import { ApiRequest } from './apiclient.js';

export class AuthClient
{
    constructor ()
    {
        this.user = null;
        // Null until asked. The February production build has no backend at
        // all, so the answer decides whether the account button exists.
        this.available = null;
        this.listeners = [];
    }

    SubscribeToChanges (listener)
    {
        this.listeners.push (listener);
    }

    NotifyListeners ()
    {
        for (let listener of this.listeners) {
            listener (this.user);
        }
    }

    IsSignedIn ()
    {
        return this.user !== null;
    }

    // Asks the backend who is signed in, and by the same request finds out
    // whether there is a backend at all.
    async Probe ()
    {
        try {
            let result = await ApiRequest ('GET', '/auth/me');
            this.available = true;
            this.user = result.user;
        } catch (error) {
            // 401 is a perfectly good answer: nobody is signed in, but the
            // service is there.
            this.available = (error.code === 'unauthorized');
            this.user = null;
        }
        this.NotifyListeners ();
        return this.available;
    }

    async Register (email, password)
    {
        let result = await ApiRequest ('POST', '/auth/register', { email : email, password : password });
        this.user = result.user;
        this.NotifyListeners ();
        return this.user;
    }

    async Login (email, password)
    {
        let result = await ApiRequest ('POST', '/auth/login', { email : email, password : password });
        this.user = result.user;
        this.NotifyListeners ();
        return this.user;
    }

    async Logout ()
    {
        await ApiRequest ('POST', '/auth/logout');
        this.user = null;
        this.NotifyListeners ();
    }

    async ChangePassword (current, next)
    {
        return ApiRequest ('POST', '/auth/password', { current : current, next : next });
    }

    async LogoutEverywhereElse ()
    {
        return ApiRequest ('POST', '/auth/logout_all');
    }
}
